define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi/def/Field",
	"csi/table/New"
], function(declare,lang,Field,New) {

	return declare(New, {
		/**
		 * Add test type field to New TestSpec form
		 */
		onCreatePopupDefView: function(defView) {
			defView.m_fields.unshift(lang.mixin(new Field(), {
				m_id: "Subtype",
				m_bRequired: true
			}));
		}
	});
});